import { Button, HStack } from "@chakra-ui/react";
import ModalContractor from "@components/modules/contractors/ModalContractor";
import { DataTable, NavBar } from "@components/ui-kit";
import { Pagination } from "@components/ui-kit/table/pagination";
import { Trans, t } from "@lingui/macro";
import {
  type ContractorsWhereColumn,
  useCreateContractorMutation,
} from "@src/__generated__/graphql";
import { Icon } from "@src/components/ui-kit/Icon";
import { FiltersPanel } from "@src/utils/components/filters/components/filters-panel";
import { can } from "@src/utils/components/permissions";
import cx from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import s from "./CardListContractors.module.css";
import { PageContractorsCtx } from "./PageContractors";
import { TableContractors } from "./table/TableContractors";

export const CardListContractors = observer(function CardListContractors() {
  const store = useContext(PageContractorsCtx);

  const [modalStore] = useState(() => new ModalContractor.Store());

  const [create, { loading: loadingCreateContractor }] =
    useCreateContractorMutation({
      onCompleted() {
        store.refetch?.();
        modalStore.toggleOpen(false);
      },
    });

  const onCreateContractor = async () => {
    const { hasError } = await modalStore.form.validateForContractor();
    if (hasError) return;
    create({
      variables: { input: modalStore.form.serialize() },
    });
  };

  return (
    <div data-testid="card-list-projects">
      <DataTable>
        <HStack justifyContent="space-between" px="4">
          <NavBar fullWidth>
            <NavBar.Item active onClick={() => {}}>
              <Trans>All</Trans>
            </NavBar.Item>
          </NavBar>
          <div className="flex items-center ml-auto">
            <div className="px-2">
              <ModalContractor.StoreContext.Provider value={modalStore}>
                {can("contractor_create") && (
                  <React.Fragment>
                    <Button
                      leftIcon={<Icon name="plus" />}
                      onClick={() => modalStore.toggleOpen()}
                    >
                      {t`Add Contractor`}
                    </Button>
                    <ModalContractor.Modal
                      title={t`Create contractor`}
                      primaryAction={{
                        onAction: onCreateContractor,
                        loading: loadingCreateContractor,
                      }}
                    />
                  </React.Fragment>
                )}
              </ModalContractor.StoreContext.Provider>
            </div>
          </div>
        </HStack>
        <hr />
        <div data-testid="filters" className={cx(s.filters, "p-6")}>
          <FiltersPanel<ContractorsWhereColumn>
            searchPlaceholder={t`Search by title, registration no., IBAN`}
            searchDefaultValue={store.searchTerm}
            onSearch={(val) => {
              store.searchTerm = val;
              store.pagination.resetPage();
            }}
          />
        </div>

        <div data-testid="table">
          <TableContractors />
          <Pagination store={store.pagination} />
        </div>
      </DataTable>
    </div>
  );
});
